const selectIsBackDropOpen = ({ snackBar: { isBackDropOpen } = {} }) =>
  isBackDropOpen;

export { selectIsBackDropOpen };
